/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "jmimgdbapi",
            "endpoint": "https://wjwirhk265.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:ff26e348-5980-4f2b-af4f-b489166e85b3",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_JCS2I28SI",
    "aws_user_pools_web_client_id": "13p20a90rdsn5de23fi61d6mue",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "jmimgdbpics120653-staging",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
